'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Timeline = require('./Timeline');

var _Timeline2 = _interopRequireDefault(_Timeline);

var _TimelineItem = require('./TimelineItem');

var _TimelineItem2 = _interopRequireDefault(_TimelineItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_Timeline2["default"].Item = _TimelineItem2["default"];
exports["default"] = _Timeline2["default"];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/timeline/index.tsx
 ** module id = 354
 ** module chunks = 0
 **/